import React from 'react';
import { Flex } from '@chakra-ui/react';
import { OrderableProvider, Orderable } from './OrderableSections';

// item 604 — DraggableCards: the friendly, ungrouped entry point to the SAME grab-handle
// drag engine the Accountant dashboard uses (OrderableProvider + Orderable). Hand it a list
// of cards; it renders them in a vertical flex column, each with a grip handle that starts a
// native HTML5 drag from the handle ONLY (the card body stays fully interactive) and a
// drop-indicator while dragging. The arrangement persists per-device in localStorage under
// `storageKey`. The `cards` array order is the DEFAULT (pre-drag) order (item 605).
export interface DraggableCard {
  id: string;
  label: string;
  node: React.ReactNode;
}

const DraggableCards: React.FC<{
  storageKey: string;
  cards: DraggableCard[];
  gap?: number | string;
}> = ({ storageKey, cards, gap }) => (
  <OrderableProvider storageKey={storageKey} ids={cards.map((c) => c.id)}>
    <Flex direction="column" sx={{ gap }}>
      {cards.map((c) => (
        <Orderable key={c.id} id={c.id} label={c.label}>
          {c.node}
        </Orderable>
      ))}
    </Flex>
  </OrderableProvider>
);

DraggableCards.defaultProps = {
  gap: '1rem',
};

export default DraggableCards;
